/**
 * @voltxampere/engine — Switch AC stamp (Sprint 22 B1)
 *
 * The switch is frequency-independent: a real conductance
 * `1/(closed ? Ron : Roff)`, imaginary part zero. Stamps the same
 * four cells the DC stamp would, via the complex matrix's
 * `(re, im)` pairs.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { getTerminalNetId } from "../terminal-utils.js";
import { resolveSwitchParams } from "../linear/switch.js";
export const switchACStamp = (ctx, component) => {
    const { closed, Ron, Roff } = resolveSwitchParams(component.id, component.params);
    const g = 1 / (closed ? Ron : Roff);
    const a = ctx.nodeIndex(getTerminalNetId(component, "t1"));
    const b = ctx.nodeIndex(getTerminalNetId(component, "t2"));
    ctx.addY(a, a, g, 0);
    ctx.addY(b, b, g, 0);
    ctx.addY(a, b, -g, 0);
    ctx.addY(b, a, -g, 0);
};
//# sourceMappingURL=switch.js.map